"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pen = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Pen = function Pen() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.8165 3.62988C15.1028 2.36943 15.7968 1.68938 18.0562 3.94877C20.3096 6.20212 19.6349 6.89419 18.3842 8.17716C18.2785 8.28557 18.1687 8.3982 18.0562 8.51635L13.4886 3.94877C13.6027 3.83946 13.7116 3.73274 13.8165 3.62988ZM12.4774 4.95999L12.475 4.96238L12.4661 4.97128C9.36856 8.07521 4.52614 12.9113 4.52614 12.9113C4.47046 12.9669 4.43056 13.0364 4.41054 13.1126L3.54808 16.3935L3.54665 16.3991L3.01429 18.4487C2.97466 18.6012 3.01877 18.7633 3.13022 18.8748C3.24167 18.9862 3.40379 19.0303 3.55634 18.9907L5.61024 18.4572L5.61024 18.4572L5.61148 18.4569L8.8924 17.5944C8.96856 17.5744 9.03804 17.5345 9.09373 17.4788L17.0313 9.5413L17.0337 9.53886L17.0426 9.52996L12.4774 4.95999Z"
    })
  });
};
exports.Pen = Pen;